import LazyLoad from "vanilla-lazyload";
var spot,
    options;
(function (window, document, $) {
    $(document).ready(function () {
        /* Functionality for the Gallery  215 */
        function setPadding() {
            $(".gallery_spot").each(function () {
                var imagePaddingInPixels = $(this).find(".thumbnails_container").data("image-padding"),
                    removeSidePaddings = $(this).find(".thumbnails_container").data('remove-side-paddings'),
                    items = $(this).find(".wrapper"),
                    count = items.length,
                    gallerySpot = $(this),
                    desktopBreakPoint = 959;

                var setImageDimentions = function ($image, imagePaddingInPixels) {
                    $image.css({
                        'width': 'calc(100% - ' + imagePaddingInPixels + 'px)',
                        'height': 'calc(100% - ' + imagePaddingInPixels + 'px)'
                    });
                };

                var isDesktop = function () {
                    return window.innerWidth > desktopBreakPoint;
                };

                var setSideMargins = function ($item, $image, imagePaddingInPixels) {
                    if (isDesktop()) {
                        $image.css({
                            'width': 'calc(100% - ' + imagePaddingInPixels / 2 + 'px)',
                            'height': 'calc(100% - ' + imagePaddingInPixels + 'px)'
                        });
                        $item.css("text-align", "right");
                        $item.find('.hover').css("left", imagePaddingInPixels / 2);
                    } else {
                        $item.css("text-align", "left");
                        $item.find('.hover').css("left", 0);
                        setImageDimentions($image, imagePaddingInPixels);
                    }
                };

                items.each(function (index) {
                    var $image = $(this).find("img, .hover");

                    if (removeSidePaddings) {
                        //middle part
                        if (index !== 0 && index !== count - 1) {
                            if (isDesktop()) {
                                $(this).css("text-align", "center");
                                $(this).find('.hover').css("left", imagePaddingInPixels / 2);
                            } else {
                                $(this).css("text-align", "left");
                                $(this).find('.hover').css("left", 0);
                            }

                            setImageDimentions($image, imagePaddingInPixels, imagePaddingInPixels);
                        }
                        //first and last
                        if (index === 0 || index === count - 1) {
                            if (index === count - 1) {
                                setSideMargins($(this), $image, imagePaddingInPixels);
                            } else {
                                setImageDimentions($image, imagePaddingInPixels);
                            }
                        }
                    } else {
                        setImageDimentions($image, imagePaddingInPixels);
                        if (index === count - 1) {
                            gallerySpot.css("marginLeft", imagePaddingInPixels + 'px');
                        }
                    }
                });
            });
        }

        setPadding();

        $(window).on('resize', function () {
            if ($(".gallery_spot").length > 0 && window.innerWidth < 960) {
                setPadding();
            }
        });

        if ($('section .gallery').length > 0) {
            ;
            (function () {

                var Gallery = {
                    dom: {
                        base: $('section .gallery'),
                        marker: $('section .gallery .gallery-markers .gallery-position'),
                        thumb: $('section .gallery .gallery-thumbs .gallery-position'),
                        image: $('section .gallery .gallery-images .gallery-position')
                    },
                    set: {
                        activeIndex: 0,
                        randomIndex: 0,
                        remainingThumbs: [0, 1, 2, 3, 4, 5],
                        animating: false,
                        hideDelay: 50,
                        hideSpeed: 1000
                    },
                    fn: {
                        showImage: function () {
                            $set.animating = true;
                            /* First show the background image */
                            $dom.image.eq($set.activeIndex).show();

                            /* Hide the thumbs one by one in quick succession, start with the active index */
                            // $fn.hideThumb($set.activeIndex);
                            // $fn.removeRandomThumb();
                            $dom.thumb.hide();
                        },
                        removeRandomThumb: function () {
                            if ($set.remainingThumbs.length > 0) {
                                setTimeout(function () {
                                    $set.randomIndex = Math.round(Math.random() * ($set.remainingThumbs.length - 1));
                                    $fn.hideThumb($set.randomIndex);

                                    $fn.removeRandomThumb();
                                }, $set.hideDelay);
                            } else {
                                $set.animating = false;
                            }
                        },
                        hideThumb: function (index) {
                            $dom.thumb.eq(index).fadeOut($set.hideSpeed);
                            $set.remainingThumbs.splice(index, 1);
                        },
                        hideImage: function () {
                            $dom.thumb.show();
                            $dom.image.hide();
                        }
                    }
                },
                    /* Add quick access variables to be used in local function
                     * Keep main variable name in case it needs to be shared with other JS files
                     */
                    $dom = Gallery.dom,
                    $set = Gallery.set,
                    $fn = Gallery.fn;

                $dom.marker.on({
                    mouseenter: function () {
                        $set.activeIndex = $(this).index();

                        $fn.showImage();
                    },
                    mouseleave: function () {
                        $fn.hideImage();
                    }
                });

            })();
        }
    });

})(window, document, jQuery);

// GallerySpot javascript
var gallerySpotHandler = (function ($) {
    var gallerySpots = [];

    function GallerySpot(spot, options) {
        this.spot = spot;
        this.options = options;
    }

    function addGallerySpot() {
        var gallerySpot = new GallerySpot(spot, options);
        gallerySpots.push(gallerySpot);
        gallerySpot.init();
    }

    GallerySpot = function (spot, options) {
        var currentGallerySpot = spot;
        var imagesLoaded = require('imagesloaded');
        imagesLoaded.makeJQueryPlugin($);

        // Options
        var options = options;
        var animationTime = 400;
        var isLightBox = false;
        var isFilter = false;
        var isLightBoxImageVideoOnly = false;
        var galleryName = "Gallery";
        var lightboxPath = "/";
        var thumbnailSize = "thumbnail-small";
        var thumbnailAspectRatio = "four-by-three";
        var openGalleryByDefault = false;

        var galleryContent;
        var thumbnails;
        var categoryAllText;
        var galleryContentCloseButton;
        var filterItems;
        var thumbnailsContainer;
        var lazyLoadInstance = new LazyLoad({
            data_src: "original",
            elements_selector: '.lazy',
            container: document.querySelector('.gallery_spot')
        });
        function init() {
            if (currentGallerySpot) {
                initLocalVariables();
                handleOptions(options);
                bindContentClickEvent();
                bindHoverEvents();
                buildCategoryList();
                bindCategoryEvents();
                setupThumbnailAspectRatio();
                attachIsotope();
                if (isFilter) {
                    buildFilterItemList();
                }

                if (openGalleryByDefault === "true" && thumbnails.length > 0) {
                    thumbnails[0].click();
                }
            }
        }


        function attachIsotope() {
            if (thumbnailsContainer && Isotope) {
                thumbnailsContainer.isotope({
                    itemSelector: '.jsthumbnail'
                });
            }

        }

        function initLocalVariables() {
            if (currentGallerySpot) {
                thumbnailsContainer = $(currentGallerySpot).find('.thumbnails_container');
                thumbnails = $(currentGallerySpot).find('.jsthumbnail');
                categoryAllText = $(currentGallerySpot).find("#hidCategoryAllText").val();
                galleryContent = $(currentGallerySpot).find("#gallery_content");
                galleryContentCloseButton = galleryContent.children(".gallery-close-button");
            }
        }

        function handleOptions(options) {
            if (options) {
                var contentRenderStr = options.contentRender;
                if (contentRenderStr == "lightbox") {
                    isLightBox = true;
                }
                // this option is extended to support videos
                if (contentRenderStr == "lightboximageonly") {
                    isLightBoxImageVideoOnly = true;
                }
                if (contentRenderStr == "filter") {
                    isFilter = true;
                }

                if (options.galleryName) {
                    galleryName = options.galleryName;
                }

                if (options.lightboxPath) {
                    lightboxPath = options.lightboxPath;
                }

                if (options.thumbnailAspectRatio) {
                    thumbnailAspectRatio = options.thumbnailAspectRatio;
                }

                if (options.thumbnailSize) {
                    thumbnailSize = options.thumbnailSize;
                }

                if (options.openGalleryByDefault) {
                    openGalleryByDefault = options.openGalleryByDefault;
                }
            }
        }

        function setupThumbnailAspectRatio() {
            $(thumbnails).addClass(thumbnailSize);
            $(thumbnails).find(".aspect-ratio").addClass(thumbnailAspectRatio);
        }

        function bindContentClickEvent() {
            if (isLightBox) {
                lightboxContentClick();
            } else if (isLightBoxImageVideoOnly) {
                // this function was extended to support videos as well
                lightboxImageVideoOnlyContentClick();
            } else if (isFilter) {
                filterContentClick();
            } else {
                standardContentClick();
            }
        }

        function standardContentClick() {
            thumbnails.click(function (event) {
                
                lazyLoadInstance.loadAll();
                resetThumbnailHoverEffects();
                showHoverForThumbnail(this);


                var htmlToSHow = $(this).next('.js_placeholder').html();
                var galleryIsVisible = galleryContent.is(":visible");
                var newImageHeight = $(this).next('.js_placeholder').css('height');
                var newImageWidth = $(this).next('.js_placeholder').css('width');
                if (galleryIsVisible) {
                    galleryContent.children(".gallery-content-html").animate({
                        width: newImageWidth,
                        height: newImageHeight
                    }, {
                        queue: false,
                        duration: animationTime
                    });
                    
                    galleryContent.children(".gallery-content-html").fadeOut(animationTime / 2, function () {
                    
                        galleryContent.children(".gallery-content-html").html(htmlToSHow);
                        galleryContent.children(".gallery-content-html").fadeIn(animationTime / 2);
                    });
                }

                // We only do an animation the first time we show the gallery
                if (!galleryIsVisible) {
                    galleryContentCloseButton.show();
                    galleryContentCloseButton.css('opacity', 1);
                    galleryContent.children(".gallery-content-html").html(htmlToSHow);
                    galleryContent.css('opacity', 0).slideDown(animationTime).animate({
                        opacity: 1
                    }, {
                        queue: false,
                        duration: animationTime
                    });

                }
            });

            galleryContentCloseButton.click(function () {
                hideGalleryContent();
                resetThumbnailHoverEffects();
            });
        }

        function hideGalleryContent() {
            if (isFilter) {
                if (filterItems) {
                    filterItems.filter(":visible").slideUp(animationTime).animate({
                        opacity: 0
                    }, {
                        queue: false,
                        duration: animationTime
                    });
                }
            } else {
                galleryContent.slideUp(animationTime).animate({
                    opacity: 0
                }, {
                    queue: false,
                    duration: animationTime
                });
                galleryContentCloseButton.animate({
                    opacity: 0
                }, {
                    queue: false,
                    duration: animationTime
                });
            }
        }

        function lightboxContentClick() {

            // Fix for LazyLoad.
            $(currentGallerySpot).find("img").each(function () {
                $(this).attr("src", $(this).attr("data-original"));
                
            });

            $(currentGallerySpot).imagesLoaded().always(function () {
                var height = $(window).height() * 0.8;
                $(currentGallerySpot).find('.jsthumbnail:not(".hidden") > div').each(function () {
                    var galleryContentPlaceHolderId = $(this).parent().next(".js_placeholder").attr("id");
                    var current_height = $(this).parent().next(".js_placeholder").height();
                    
                    if (current_height < height) {
                        height = current_height;
                    }
                    $(this).wrap("<a href='" + lightboxPath + "#" + galleryContentPlaceHolderId + "' class='galleryLink' title=''></a>");
                });

                window.Shadowbox.setup($(currentGallerySpot).find('.jsthumbnail:not(".hidden") > a.galleryLink'), {
                    gallery: galleryName,
                    width: 960,
                    height: height,
                    player: "inline"
                });
            });
        }

        function lightboxImageVideoOnlyContentClick() {

            // Fix for LazyLoad.
            $(currentGallerySpot).find("img").each(function () {
                $(this).attr("src", $(this).attr("data-original"));
            });

            $(currentGallerySpot).find('.jsthumbnail:not(".hidden") > div').each(function () {
                if ($(this).parent().next(".js_placeholder").find(".videoSpot23").length) {
                    var galleryContentPlaceHolderId = $(this).parent().next(".js_placeholder").find("iframe");
                    if (galleryContentPlaceHolderId.attr("width") == undefined || galleryContentPlaceHolderId.attr("height") == undefined) {
                        var widthVideo = 625;
                        var heightVideo = 352;
                    } else {
                        var widthVideo = galleryContentPlaceHolderId.attr("width");
                        var heightVideo = galleryContentPlaceHolderId.attr("height");
                    }
                    $(this).wrap("<a href='" + galleryContentPlaceHolderId.attr("src") + "' rel='shadowbox[" + galleryName + "];player=iframe;width=" + widthVideo + ";height=" + heightVideo + ";' class='galleryLink'></a>");
                } else {
                    var galleryContentPlaceHolderId = $(this).parent().next(".js_placeholder").find("img").attr("src");
                    $(this).wrap("<a href='" + galleryContentPlaceHolderId + "' rel='shadowbox[" + galleryName + "];player=img' class='galleryLink'></a>");
                }
            });

        }

        function filterContentClick() {
            thumbnails.click(function (event) {
                event.preventDefault();
                resetThumbnailHoverEffects();
                showHoverForThumbnail(this);

                var filterItemsData = $(this).data("filteritems").split(',');
                if (filterItemsData) {
                    var filterItemsIds = [];
                    $(filterItemsData).each(function () {
                        var filterItemId = "#" + this.toString();
                        filterItemsIds.push(filterItemId);


                    });

                    var currentFilterItems = $(filterItemsIds.join(","));
                    if (currentFilterItems.is(":visible")) {
                        currentFilterItems.slideUp(animationTime).animate({
                            opacity: 0
                        }, {
                            queue: false,
                            duration: animationTime
                        });
                    } else {
                        if (filterItems.is(":visible")) {
                            filterItems.filter(":visible").fadeOut(animationTime / 2, function () {
                                currentFilterItems.css('opacity', 1).fadeIn(animationTime / 2);
                            });
                        } else {
                            currentFilterItems.css('opacity', 0).slideDown(animationTime).animate({
                                opacity: 1
                            }, {
                                queue: false,
                                duration: animationTime
                            });
                            //we scroll to the thumbnail, or to the content (in mobile/tablet)
                            var scrollt = ($(window).width() < 960) ? currentFilterItems.first().offset().top : $(this).offset().top;
                            $('html, body').animate({
                                scrollTop: scrollt
                            }, {
                                queue: false,
                                duration: animationTime
                            });
                        }
                    }
                }
            });
        }

        function buildFilterItemList() {
            var distinctFilterItems = [];
            $(thumbnails).each(function () {
                var currentFilterData = $(this).data("filteritems");
                if (currentFilterData !== "") {
                    var filterItemsString = currentFilterData.split(",");
                    $(filterItemsString).each(function () {
                        if ($.inArray(this.toString(), distinctFilterItems) == -1) {
                            distinctFilterItems.push("#" + this.toString());
                        }
                    });
                }
            });
            filterItems = $(distinctFilterItems.join(","));
        }

        function buildCategoryList() {
            // Build distinct gallery categories list
            var thumbnails = $(currentGallerySpot).find(".jsthumbnail");
            var categoriesContainer = $(currentGallerySpot).find("#gallery_categories");
            var categoryAllText = $(currentGallerySpot).find("#hidCategoryAllText").val();
            var distinctCategories = [];
            $(thumbnails).each(function () {
                var categoriesString = $(this).data("categories")
                var categoriesArray = categoriesString.split(",");
                if (categoriesString !== "" && categoriesArray.length > 0) {
                    $(categoriesArray).each(function () {
                        if ($.inArray(this.toString(), distinctCategories) == -1) {
                            distinctCategories.push(this.toString());
                        }
                    });
                }
            });

            distinctCategories.sort(function (a, b) {
                return parseInt(a.split(";")[1]) - parseInt(b.split(";")[1]);
            });

            if (categoryAllText != "") {
                categoriesContainer.append("<a class='gallery_categorylink selected' data-filter='*'>" + categoryAllText + "</a>");
            }

            $(distinctCategories).each(function () {
                categoriesContainer.append("<a class='gallery_categorylink' data-filter='." + this.split(";")[2] + "'>" + this.split(";")[0] + "</a>");
            });
        }

        function bindCategoryEvents() {
            //Event handling for gallery categories
            $(currentGallerySpot).find(".gallery_categorylink").click(function (event) {
                var $this = $(this);
                event.preventDefault();

                resetThumbnailHoverEffects();

                var currentCategory = $this.html();
                var categories = $this.siblings(".gallery_categorylink");

                $(categories).removeClass("selected");
                $this.addClass("selected");

                var $optionSet = $this.parents('.option-set');
                var options = {};
                var key = $optionSet.attr('data-option-key');
                var value = $this.attr('data-filter');
                options[key] = value;
                $(thumbnailsContainer).isotope(options);

                hideGalleryContent();

                if (isLightBox || isLightBoxImageVideoOnly) {
                    clearShadowboxCache();
                }

                return false;
            });
        }

        function bindHoverEvents() {
            thumbnails.mouseenter(function () {
                $(this).find('.hover').addClass('hover_overlay');
                $(this).find('.hover').show();

            });

            thumbnails.mouseleave(function () {
                $(this).find('.hover').removeClass('hover_overlay');
                $(this).find('.hover').hide();
            });
        }

        function resetThumbnailHoverEffects() {
            removeAllThumbnailHoverEffects();
            bindHoverEvents();
        }

        function showHoverForThumbnail(thumbnail) {
            $(thumbnail).find('.hover').addClass('hover_overlay').show();
            $(thumbnail).unbind("mouseleave");
        }

        function removeAllThumbnailHoverEffects() {
            thumbnails.find('.hover').removeClass('hover_overlay').hide();
        }

        function clearShadowboxCache() {
            console.log(window.Shadowbox.init());
            window.Shadowbox.clearCache();

            // Run through all other galleryspots and rebind the shadowbox links
            // if this isn't done shadowbox will only work for the current GallerySpot
            for (var i = 0; i < gallerySpots.length; i++) {
                var tmpSpot = gallerySpots[i];
                tmpSpot.reInitShadowbox();
            }
        }

        function reInitShadowbox() {
            if (isLightBox) {
                lightboxContentClick();
            }
            if (isLightBoxImageVideoOnly) {
                lightboxImageVideoOnlyContentClick();
            }
        }

        return {
            init: init,
            reInitShadowbox: reInitShadowbox
        }
    }

    return {
        add: addGallerySpot
    }
})(jQuery);


function fetchData($spot, $options) {
    spot = $spot;
    options = $options;
    gallerySpotHandler.add(spot, options);
}
window.fetchData = fetchData;